import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const CancellationPolicy = () => (
  <div className="min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-pink-50 to-indigo-50 py-12 px-2">
    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full p-8 md:p-12">
      <div className="flex items-center justify-center mb-4">
        <ArrowPathIcon className="h-10 w-10 text-pink-500 mr-2" />
        <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-500 drop-shadow">
          Cancellation & Refund Policy
        </h1>
      </div>
      <p className="mb-6 text-lg text-gray-700 text-center">
        We want you to love your shopping experience. Please read our policy below:
      </p>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Order Cancellation</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">Orders can be cancelled before they are shipped. Once shipped, cancellation is not possible.</li>
          <li className="marker:text-pink-500">To cancel, contact us at <a href='mailto:thevastra.store1999@gmail.com' className='text-indigo-600 underline'>thevastra.store1999@gmail.com</a> or WhatsApp within 12 hours of placing your order.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Refund Process</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">If your order is eligible for a refund, it will be processed to your original payment method within 5-7 business days after approval.</li>
          <li className="marker:text-pink-500">You will receive a confirmation email once your refund is initiated.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Eligibility for Refunds</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">Refunds are only applicable for damaged, defective, or incorrect items.</li>
          <li className="marker:text-pink-500">To be eligible, you must contact us within 48 hours of delivery with photos and order details.</li>
          <li className="marker:text-pink-500">Items must be unused, unwashed, and in original packaging.</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Timelines & Contact</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">Refunds are processed within 5-7 business days after approval.</li>
          <li className="marker:text-pink-500">For any questions, email <a href='mailto:thevastra.store1999@gmail.com' className='text-indigo-600 underline'>thevastra.store1999@gmail.com</a> or WhatsApp us.</li>
        </ul>
      </section>
      <div className="text-right text-sm text-gray-500">Last updated: July 2024</div>
    </div>
  </div>
);

export default CancellationPolicy; 